import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";

const PrivateRoute = ({
  element: Component,
  isAdminRoute,
  auth,
  ...rest
}) => {
    if(!auth.isLoggedIn || (
        isAdminRoute === true && auth.user?.admin !== true
    )) {
        return <Navigate to="/" />
    }
    return <Component {...rest} />
}

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  isAdminRoute: PropTypes.bool.isRequired,
};

PrivateRoute.defaultProps = {
  isAdminRoute: false,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
